import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { useCookieConsent } from "./CookieConsentContext";

export default function VirtualTour() {
  const { consent } = useCookieConsent();
  const [manualConsent, setManualConsent] = useState(false);

  const canLoad = consent?.externalMedia || manualConsent;

  return (
    <section
      id="tour"
      className="relative py-28 md:py-36 px-6 md:px-12 lg:px-20 section-alt overflow-hidden"
      data-testid="virtual-tour-section"
    >
      <div className="hidden 2xl:block absolute bottom-0 left-0 w-96 h-96 bg-gold/10 blur-[140px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="skull-divider mb-6">
            <span className="font-space-grotesk text-xs text-gold tracking-[0.3em] uppercase px-3">360° Rundgang</span>
          </div>
          <h2 className="font-unbounded text-4xl sm:text-5xl lg:text-6xl font-black text-cream leading-tight">
            Erkunde unser{" "}
            <span className="gold-gradient-text">Center</span>
          </h2>
          <p className="font-space-grotesk text-cream-muted text-sm md:text-base mt-5 max-w-lg mx-auto text-center leading-relaxed">
            Schau dich um, bevor du vorbeikommst – virtuell durch alle Bereiche navigieren.
          </p>
        </motion.div>

        {/* Matterport Embed */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="glass border border-white/5 rounded-2xl overflow-hidden gold-glow-hover"
          data-testid="virtual-tour-embed"
        >
          {canLoad ? (
            <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
              <iframe
                src="https://my.matterport.com/show/?m=jzmmj2igqYF"
                title="Virtueller Rundgang – Pirate Bowling Center Velburg"
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allowFullScreen
                allow="autoplay; fullscreen; web-share; xr-spatial-tracking"
                loading="lazy"
              />
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-8 md:py-12 px-6">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gold/10 border border-gold/25 flex items-center justify-center mb-3">
                <Play className="w-4 h-4 md:w-5 md:h-5 text-gold ml-0.5" />
              </div>
              <p className="font-unbounded text-sm md:text-base font-bold text-cream mb-1 text-center">
                Virtueller Rundgang
              </p>
              <p className="font-inter text-[11px] md:text-xs text-cream/50 text-center max-w-md mb-3 md:mb-4">
                Beim Laden werden Daten an Matterport übertragen.
              </p>
              <button
                onClick={() => setManualConsent(true)}
                className="btn-gold px-5 py-2 md:px-7 md:py-2.5 rounded-full text-[11px] md:text-xs"
                data-testid="virtual-tour-consent-btn"
              >
                Rundgang starten
              </button>
            </div>
          )}
        </motion.div>

      </div>
    </section>
  );
}
